import React, { Component } from 'react';
import { connect } from 'react-redux';
import SignInComponent from '../../components/signin/signin';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import {bindActionCreators} from "redux"
import { signIn,verifyUser } from '../../../../core/actions/auth';
import {Helmet} from "react-helmet";

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    var url = new URLSearchParams(window.location.search);
    var token = url.get("emailVerificationToken");
    if(token){
      this.props.verifyUser(token)
    }
    if (this.props.auth.uid ) {
      this.props.history.push('/');
    }
  }
  componentWillReceiveProps(nextProps) {
    var {auth,profile} = nextProps
    // if (auth.uid && profile.isLoaded) {
    //   localStorage.setItem('role', profile.role);
    //   localStorage.setItem('uid', profile.uid);
    //   // localStorage.setItem('plan', profile.plan);
    //   this.props.history.push('/');
    // }
  }

  render() {

    return (
      <div className="signin-page">
        <Helmet>
          <title>Sign in to continue</title>
          <meta name="description" content="Ready to get started? orsity has many free community resource courses for you to start learning today. Sign in now!" />
        </Helmet>
        <TopNav history={this.props.history} />
        <section >
         
              <SignInComponent 
              history={this.context.router}
              signIn={this.props.signIn}
              localAuth={this.props.localAuth}
               />
          <Footer />
        </section>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile:state.firebase.profile,
  localAuth:state.auth
});

const mapDispatchToProps = dispatch => bindActionCreators({
  signIn: signIn,
  verifyUser
},dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn);
